import React from 'react'

import Layout from '../components/layout'
import SEO from '../components/seo'

const NotFoundPage = () => (
  <Layout>
    <SEO title="404: Not found" />
    <br/>
    <br/>
    <br/>
    <center>
    <h1>Oops, wrong page</h1>
    <p>Are you looking for the dashboard? <a href="https://app.hyperping.io" rel="noopener noreferrer">Click here!</a></p>
    </center>
  </Layout>
)

export default NotFoundPage
